// Known-good snapshot of /v1/survey/locations/city-profile, used only as the
// initial value for cityList in NavigationButtons.js so the District/City
// dropdowns have real options before the live fetch resolves. The live fetch
// (fetchCityListCached) still runs and overwrites this with authoritative
// data, so newly added cities/districts show up as soon as it completes.
export const DEFAULT_CITY_LIST = [
  { id: 1381, name: "Ajmiriganj", type: "MUNICIPALITY", district: "Habiganj" },
  { id: 1390, name: "Alamdanga", type: "MUNICIPALITY", district: "Chuadanga" },
  { id: 1660, name: "Araihazar", type: "MUNICIPALITY", district: "Narayanganj" },
  { id: 1826, name: "Arani", type: "MUNICIPALITY", district: "Rajshahi" },
  { id: 1306, name: "Bagerhat", type: "MUNICIPALITY", district: "Bagerhat" },
  { id: 1920, name: "Banaripara", type: "MUNICIPALITY", district: "Barishal" },
  { id: 1307, name: "Bandarban", type: "MUNICIPALITY", district: "Bandarban" },
  { id: 2025, name: "Banshkhali", type: "MUNICIPALITY", district: "Chattogram" },
  { id: 1308, name: "Barguna", type: "MUNICIPALITY", district: "Barguna" },
  { id: 1309, name: "Barishal", type: "CITY_CORPORATION", district: "Barishal" },
  { id: 1399, name: "Basurhat", type: "MUNICIPALITY", district: "Noakhali" },
  { id: 1736, name: "Bauphal", type: "MUNICIPALITY", district: "Patuakhali" },
  { id: 1821, name: "Beanibazar", type: "MUNICIPALITY", district: "Sylhet" },
  { id: 1408, name: "Belkuchi", type: "MUNICIPALITY", district: "Sirajganj" },
  { id: 1372, name: "Benapole", type: "MUNICIPALITY", district: "Jashore" },
  { id: 1592, name: "Bera", type: "MUNICIPALITY", district: "Pabna" },
  { id: 2029, name: "Betagi", type: "MUNICIPALITY", district: "Barguna" },
  { id: 1310, name: "Bhola", type: "MUNICIPALITY", district: "Bhola" },
  { id: 1444, name: "Birganj", type: "MUNICIPALITY", district: "Dinajpur" },
  { id: 1417, name: "Boalmari", type: "MUNICIPALITY", district: "Faridpur" },
  { id: 1311, name: "Bogura", type: "MUNICIPALITY", district: "Bogura" },
  { id: 1312, name: "Brahmanbaria", type: "MUNICIPALITY", district: "Brahmanbaria" },
  { id: 1784, name: "Chakaria", type: "MUNICIPALITY", district: "Cox's Bazar" },
  { id: 1313, name: "Chandpur", type: "MUNICIPALITY", district: "Chandpur" },
  { id: 1314, name: "Chapai Nawabganj", type: "MUNICIPALITY", district: "Ch. Nawabganj" },
  { id: 1929, name: "Charghat", type: "MUNICIPALITY", district: "Rajshahi" },
  { id: 1453, name: "Chatkhil", type: "MUNICIPALITY", district: "Noakhali" },
  { id: 1661, name: "Chauddagram", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 1750, name: "Chhatak", type: "MUNICIPALITY", district: "Sunamganj" },
  { id: 1316, name: "Chuadanga", type: "MUNICIPALITY", district: "Chuadanga" },
  { id: 1369, name: "Cox's Bazar", type: "MUNICIPALITY", district: "Cox's Bazar" },
  { id: 1317, name: "Cumilla", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 2005, name: "Daudkandi", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 1851, name: "Debidwar", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 1602, name: "Dewanganj", type: "MUNICIPALITY", district: "Jamalpur" },
  { id: 1463, name: "Dhamrai", type: "MUNICIPALITY", district: "Dhaka" },
  { id: 1318, name: "Dinajpur", type: "MUNICIPALITY", district: "Dinajpur" },
  { id: 1472, name: "Dohar", type: "MUNICIPALITY", district: "Dhaka" },
  { id: 1319, name: "Faridpur", type: "MUNICIPALITY", district: "Faridpur" },
  { id: 1320, name: "Feni", type: "MUNICIPALITY", district: "Feni" },
  { id: 1698, name: "Gafargaon", type: "MUNICIPALITY", district: "Mymensingh" },
  { id: 1321, name: "Gaibandha", type: "MUNICIPALITY", district: "Gaibandha" },
  { id: 1917, name: "Galachipa", type: "MUNICIPALITY", district: "Patuakhali" },
  { id: 1323, name: "Gazipur", type: "CITY_CORPORATION", district: "Gazipur" },
  { id: 1481, name: "Ghatail", type: "MUNICIPALITY", district: "Tangail" },
  { id: 1984, name: "Goalanda", type: "MUNICIPALITY", district: "Rajbari" },
  { id: 1490, name: "Gobindaganj", type: "MUNICIPALITY", district: "Gaibandha" },
  { id: 1499, name: "Godagari", type: "MUNICIPALITY", district: "Rajshahi" },
  { id: 1324, name: "Gopalganj", type: "MUNICIPALITY", district: "Gopalganj" },
  { id: 1968, name: "Lalpur", type: "MUNICIPALITY", district: "Natore" },
  { id: 1325, name: "Habiganj", type: "MUNICIPALITY", district: "Habiganj" },
  { id: 1895, name: "Hajiganj", type: "MUNICIPALITY", district: "Chandpur" },
  { id: 1959, name: "Hakimpur", type: "MUNICIPALITY", district: "Dinajpur" },
  { id: 2014, name: "Ishwardi", type: "MUNICIPALITY", district: "Pabna" },
  { id: 1670, name: "Islampur", type: "MUNICIPALITY", district: "Jamalpur" },
  { id: 1508, name: "Jagannathpur", type: "MUNICIPALITY", district: "Sunamganj" },
  { id: 1326, name: "Jamalpur", type: "MUNICIPALITY", district: "Jamalpur" },
  { id: 1327, name: "Jashore", type: "MUNICIPALITY", district: "Jashore" },
  { id: 1328, name: "Jhalokathi", type: "MUNICIPALITY", district: "Jhalokathi" },
  { id: 1329, name: "Jhenaidah", type: "MUNICIPALITY", district: "Jhenaidah" },
  { id: 1330, name: "Joypurhat", type: "MUNICIPALITY", district: "Joypurhat" },
  { id: 1863, name: "Kalaroa", type: "MUNICIPALITY", district: "Satkhira" },
  { id: 1667, name: "Kaliakair", type: "MUNICIPALITY", district: "Gazipur" },
  { id: 1620, name: "Kalihati", type: "MUNICIPALITY", district: "Tangail" },
  { id: 1757, name: "Kalkini", type: "MUNICIPALITY", district: "Madaripur" },
  { id: 1740, name: "Kamalganj", type: "MUNICIPALITY", district: "Moulvibazar" },
  { id: 1517, name: "Kanaighat", type: "MUNICIPALITY", district: "Sylhet" },
  { id: 1820, name: "Karimganj", type: "MUNICIPALITY", district: "Kishoreganj" },
  { id: 1331, name: "Khagrachhari", type: "MUNICIPALITY", district: "Khagrachhari" },
  { id: 1332, name: "Kishoreganj", type: "MUNICIPALITY", district: "Kishoreganj" },
  { id: 1333, name: "Kurigram", type: "MUNICIPALITY", district: "Kurigram" },
  { id: 1334, name: "Kushtia", type: "MUNICIPALITY", district: "Kushtia" },
  { id: 1978, name: "Laksam", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 1335, name: "Lakshmipur", type: "MUNICIPALITY", district: "Lakshmipur" },
  { id: 1336, name: "Lalmonirhat", type: "MUNICIPALITY", district: "Lalmonirhat" },
  { id: 1337, name: "Madaripur", type: "MUNICIPALITY", district: "Madaripur" },
  { id: 1526, name: "Madhabdi", type: "MUNICIPALITY", district: "Narsingdi" },
  { id: 1338, name: "Magura", type: "MUNICIPALITY", district: "Magura" },
  { id: 1339, name: "Manikganj", type: "MUNICIPALITY", district: "Manikganj" },
  { id: 1536, name: "Manirampur", type: "MUNICIPALITY", district: "Jashore" },
  { id: 1795, name: "Monohardi", type: "MUNICIPALITY", district: "Narsingdi" },
  { id: 1340, name: "Meherpur", type: "MUNICIPALITY", district: "Meherpur" },
  { id: 1341, name: "Moulvibazar", type: "MUNICIPALITY", district: "Moulvibazar" },
  { id: 1805, name: "Muksudpur", type: "MUNICIPALITY", district: "Gopalganj" },
  { id: 1777, name: "Muktagacha", type: "MUNICIPALITY", district: "Mymensingh" },
  { id: 1545, name: "Muladi", type: "MUNICIPALITY", district: "Jhalokathi" },
  { id: 1342, name: "Munshiganj", type: "MUNICIPALITY", district: "Munshiganj" },
  { id: 1343, name: "Mymensingh", type: "CITY_CORPORATION", district: "Mymensingh" },
  { id: 1866, name: "Nabiganj", type: "MUNICIPALITY", district: "Habiganj" },
  { id: 1554, name: "Nabinagar", type: "MUNICIPALITY", district: "Brahmanbaria" },
  { id: 2002, name: "Nagarkanda", type: "MUNICIPALITY", district: "Faridpur" },
  { id: 1876, name: "Nageshwari", type: "MUNICIPALITY", district: "Kurigram" },
  { id: 1708, name: "Nangalkot", type: "MUNICIPALITY", district: "Cumilla" },
  { id: 1345, name: "Naogaon", type: "MUNICIPALITY", district: "Naogaon" },
  { id: 1346, name: "Narail", type: "MUNICIPALITY", district: "Narail" },
  { id: 1347, name: "Narayanganj", type: "CITY_CORPORATION", district: "Narayanganj" },
  { id: 1348, name: "Narsingdi", type: "MUNICIPALITY", district: "Narsingdi" },
  { id: 1349, name: "Natore", type: "MUNICIPALITY", district: "Natore" },
  { id: 1350, name: "Netrokona", type: "MUNICIPALITY", district: "Netrakona" },
  { id: 1351, name: "Nilphamari", type: "MUNICIPALITY", district: "Nilphamari" },
  { id: 1352, name: "Noakhali", type: "MUNICIPALITY", district: "Noakhali" },
  { id: 1353, name: "Pabna", type: "MUNICIPALITY", district: "Pabna" },
  { id: 1925, name: "Paikgachha", type: "MUNICIPALITY", district: "Khulna" },
  { id: 1354, name: "Panchagarh", type: "MUNICIPALITY", district: "Panchagarh" },
  { id: 1874, name: "Patgram", type: "MUNICIPALITY", district: "Lalmonirhat" },
  { id: 1355, name: "Patuakhali", type: "MUNICIPALITY", district: "Patuakhali" },
  { id: 1356, name: "Pirojpur", type: "MUNICIPALITY", district: "Pirojpur" },
  { id: 1793, name: "Raipura", type: "MUNICIPALITY", district: "Narsingdi" },
  { id: 1357, name: "Rajbari", type: "MUNICIPALITY", district: "Rajbari" },
  { id: 1358, name: "Rajshahi", type: "CITY_CORPORATION", district: "Rajshahi" },
  { id: 1359, name: "Rangamati", type: "MUNICIPALITY", district: "Rangamati" },
  { id: 1361, name: "Rangpur", type: "CITY_CORPORATION", district: "Rangpur" },
  { id: 1605, name: "Rangunia", type: "MUNICIPALITY", district: "Chattogram" },
  { id: 1712, name: "Satkania", type: "MUNICIPALITY", district: "Chattogram" },
  { id: 1362, name: "Satkhira", type: "MUNICIPALITY", district: "Satkhira" },
  { id: 1916, name: "Shahjadpur", type: "MUNICIPALITY", district: "Sirajganj" },
  { id: 1363, name: "Shariatpur", type: "MUNICIPALITY", district: "Shariatpur" },
  { id: 1563, name: "Shayestaganj", type: "MUNICIPALITY", district: "Habiganj" },
  { id: 1573, name: "Sherpur", type: "MUNICIPALITY", district: "Bogura" },
  { id: 658, name: "Sherpur", type: "MUNICIPALITY", district: "Sherpur" },
  { id: 1912, name: "Shibchar", type: "MUNICIPALITY", district: "Madaripur" },
  { id: 1426, name: "Shibganj", type: "MUNICIPALITY", district: "Bogura" },
  { id: 1614, name: "Singair", type: "MUNICIPALITY", district: "Manikganj" },
  { id: 1364, name: "Sirajganj", type: "MUNICIPALITY", district: "Sirajganj" },
  { id: 1964, name: "Sonaimuri", type: "MUNICIPALITY", district: "Noakhali" },
  { id: 1825, name: "Sonargaon", type: "MUNICIPALITY", district: "Narayanganj" },
  { id: 1597, name: "Sreemangal", type: "MUNICIPALITY", district: "Moulvibazar" },
  { id: 2017, name: "Sreepur", type: "MUNICIPALITY", district: "Gazipur" },
  { id: 1365, name: "Sunamganj", type: "MUNICIPALITY", district: "Sunamganj" },
  { id: 1663, name: "Sundarganj", type: "MUNICIPALITY", district: "Gaibandha" },
  { id: 1366, name: "Sylhet", type: "CITY_CORPORATION", district: "Sylhet" },
  { id: 1367, name: "Tangail", type: "MUNICIPALITY", district: "Tangail" },
  { id: 1368, name: "Thakurgaon", type: "MUNICIPALITY", district: "Thakurgaon" },
  { id: 1435, name: "Ulipur", type: "MUNICIPALITY", district: "Kurigram" },
];
